<div class="tasks-table__column-picker">
  <label class="custom-mat-select_table-column-label">{{ 'general.table.label.column' | translate }}:</label>
  <mat-form-field class="custom-mat-form-field custom-mat-select_table-column-picker" floatLabel="never">
    <mat-label>{{ 'general.table.label.select_column' | translate }}</mat-label>
    <img matSuffix class="custom-mat-select_table-column-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select [(ngModel)]="isActive" [(value)]="isActive">
      <mat-option value="type">{{ 'general.table.label.type' | translate }}</mat-option>
      <mat-option value="date">{{ 'general.table.label.date' | translate }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div class="tasks-table__container">
  <artemis-loading-spinner *ngIf="isLoading"></artemis-loading-spinner>
  <table class="custom-mat-table tasks-table custom-mat-table_first-column" mat-table matSort [dataSource]="tasksDataSource" (matSortChange)="tableSortChangeHandler($event)">
    <ng-container matColumnDef="name">
      <th class="tasks-table__column-description" mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'general.table.label.customer_name' | translate }} </th>
      <td class="tasks-table__column-description tasks-table__cell" mat-cell *matCellDef="let task" [title]="task.customerName">
        <a class="link" [routerLink]="task.type === 'DRAFT' ? ['/customers/' + task.customerId + '/edit'] : ['/customers/' + task.customerId + '/screening']">
          {{task.customerName}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th class="tasks-table__column-type" mat-header-cell *matHeaderCellDef mat-sort-header
          [ngClass]="{'mat-cell__column-active': isActive === 'type'}">
        {{'general.table.label.type' | translate}}
      </th>
      <td class="tasks-table__column-type tasks-table__cell" mat-cell *matCellDef="let task" [title]="task.type"
          [ngClass]="{'mat-cell__column-active': isActive === 'type'}">
        <span>{{task.type}}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th class="tasks-table__column-date" mat-header-cell *matHeaderCellDef mat-sort-header
          [ngClass]="{'mat-cell__column-active': isActive === 'date'}">
        {{ 'general.table.label.date' | translate }}
      </th>
      <td class="tasks-table__column-date tasks-table__cell" mat-cell *matCellDef="let task"
          [ngClass]="{'mat-cell__column-active': isActive === 'date'}"
          [title]="task.date ? (task.date | date:'dd/MM/yyyy \'at\' h:mm:ss a') : task.date">
        <img class="tasks-table__expiring-icon" src="/assets/icons/exclamation-icon-red.png" *ngIf="showErrorIcon">
        <span class="tasks-table__expiring-date-value">{{task.date ? (task.date | date:'dd/MM/yyyy \'at\' h:mm:ss a') : task.date}}</span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <div class="table-empty" *ngIf="tasksDataSource && tasksDataSource.data.length === 0">
    {{ 'dashboard.task_list.message.no' | translate }} {{currentTasksType + ' '}} {{ 'dashboard.task_list.message.task' | translate }}
  </div>
  <mat-paginator class="custom-mat-paginator" (page)="tablePaginationChangeHandler($event)" showFirstLastButtons
                 [pageSizeOptions]="pageSizeOptions" [pageSize]="preferredTaskTablePageSize" [length]="preferredTaskTableDataSourceLength">
  </mat-paginator>
</div>
